export default __webpack_public_path__ + "static/media/players-mob@2x.0cd81936.png";